<template>
  <div class="mt-5">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <!-- DIALOG TAMBAH / EDIT -->
        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">

            <div
              class="d-flex align-center pt-3 pb-0 px-4 body-1"
              style="font-weight: 600;">
              {{ form.id ? 'Edit Konfigurasi Arus Kas' : 'Tambah Konfigurasi Arus Kas' }}

              <v-spacer/>

              <v-icon
                @click="dialog.form = false; reset();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </div>

            <v-divider
              class="mt-3 mb-1"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text class="pt-3 pb-2 px-4">
              <ValidationObserver ref="form">
                <v-form>
                  <ValidationProvider
                    name="Section"
                    rules="required"
                    v-slot="{ errors, valid }">
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      <span class="red--text">*</span>
                      Section
                    </div>

                    <v-select
                      filled
                      rounded
                      dense
                      :color="set_color"
                      placeholder="Pilih Section"
                      hide-details="auto"
                      :items="sections"
                      item-text="name"
                      item-value="id"
                      :item-color="set_color"
                      v-model="form.section"
                      :success="valid"
                      :error-messages="errors"
                      required
                      class="mb-5"
                      style="border-radius: 10px;">
                    </v-select>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Tipe Baris"
                    rules="required"
                    v-slot="{ errors, valid }">
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      <span class="red--text">*</span>
                      Tipe Baris
                    </div>

                    <v-select
                      filled
                      rounded
                      dense
                      :color="set_color"
                      placeholder="Pilih Tipe Baris"
                      hide-details="auto"
                      :items="rowTypes"
                      item-text="name"
                      item-value="id"
                      :item-color="set_color"
                      v-model="form.row_type"
                      :success="valid"
                      :error-messages="errors"
                      required
                      class="mb-5"
                      style="border-radius: 10px;">
                    </v-select>
                  </ValidationProvider>

                  <div class="mb-2 font_weight_600 fs-13 black_one">
                    Akun COA <span class="grey--text fs-11">(opsional)</span>
                  </div>

                  <v-autocomplete
                    filled
                    rounded
                    dense
                    clearable
                    :loading="process.coa"
                    :color="set_color"
                    placeholder="Cari nama / nomor akun COA"
                    hide-details="auto"
                    :items="coaSelectItems"
                    :search-input.sync="search_coa"
                    item-text="name_number"
                    item-value="number"
                    :item-color="set_color"
                    v-model="form.coa_number"
                    @change="onCoaChange"
                    class="mb-5"
                    style="border-radius: 10px;">
                    <template v-slot:item="{ item }">
                      <div class="d-flex align-center">
                        <div class="body-2 font-weight-bold mr-2">{{ item.number }}</div>
                        <div class="caption grey--text">{{ item.name }}</div>
                      </div>
                    </template>
                  </v-autocomplete>

                  <ValidationProvider
                    name="Tipe Formula"
                    v-slot="{ errors, valid }">
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      Tipe Formula <span class="grey--text fs-11">(opsional)</span>
                    </div>

                    <v-select
                      filled
                      rounded
                      dense
                      :color="set_color"
                      placeholder="Otomatis jika dikosongkan"
                      hide-details="auto"
                      :items="formulaTypes"
                      item-text="name"
                      item-value="id"
                      :item-color="set_color"
                      v-model="form.formula_type"
                      :success="valid"
                      :error-messages="errors"
                      class="mb-5"
                      style="border-radius: 10px;">
                    </v-select>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Tipe Saldo"
                    v-slot="{ errors, valid }">
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      Tipe Saldo <span class="grey--text fs-11">(opsional)</span>
                    </div>

                    <v-select
                      filled
                      rounded
                      dense
                      :color="set_color"
                      placeholder="Otomatis dari akun COA jika dikosongkan"
                      hide-details="auto"
                      :items="balanceTypes"
                      item-text="name"
                      item-value="id"
                      :item-color="set_color"
                      v-model="form.balance_type"
                      :success="valid"
                      :error-messages="errors"
                      class="mb-5"
                      style="border-radius: 10px;">
                    </v-select>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Label"
                    :rules="labelRules"
                    v-slot="{ errors, valid }">
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      <span v-if="!form.coa_number" class="red--text">*</span>
                      Label
                      <span v-if="form.coa_number" class="grey--text fs-11">(opsional, default nama akun COA)</span>
                    </div>

                    <v-text-field
                      filled
                      rounded
                      dense
                      :color="set_color"
                      placeholder="Contoh: Penurunan (Kenaikan) Piutang"
                      hide-details="auto"
                      v-model="form.label"
                      :success="valid"
                      :error-messages="errors"
                      class="mb-3"
                      style="border-radius: 10px;">
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Urutan"
                    rules="required"
                    v-slot="{ errors, valid }">
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      <span class="red--text">*</span>
                      Urutan (Sort)
                    </div>

                    <v-text-field
                      filled
                      rounded
                      dense
                      type="number"
                      :color="set_color"
                      placeholder="Contoh: 40"
                      hide-details="auto"
                      v-model="form.sort"
                      :success="valid"
                      :error-messages="errors"
                      required
                      class="mb-3"
                      style="border-radius: 10px;">
                    </v-text-field>
                  </ValidationProvider>

                  <div class="d-flex align-center mb-2">
                    <span class="font_weight_600 fs-13 black_one mr-3">Status Aktif</span>

                    <v-switch
                      :color="set_color"
                      v-model="form.active_bool"
                      :true-value="1"
                      :false-value="0"
                      hide-details
                      inset
                      class="ma-0 pa-0">
                    </v-switch>
                  </div>

                  <div v-if="message.error.length > 0"
                    class="text-center mt-2">
                    <div class="error--text d-flex align-start">
                      <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>

                      <span class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-form>
              </ValidationObserver>
            </v-card-text>

            <v-divider
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions class="mb-2 px-4">
              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form = false; dialog.fullscreen = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- DIALOG HAPUS -->
        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          width="450"
          persistent
          scrollable>
          <v-card class="border-radius">
            <div
              class="d-flex align-center pt-3 pb-0 text-right popup-header px-4 body-1" style="font-weight: 600;">
              Hapus Konfigurasi Arus Kas

              <v-spacer/>

              <v-icon
                @click="dialog.delete = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </div>

            <v-divider
              class="mt-3 mb-1"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text class="pt-1 pb-2 px-4">
              Apakah anda yakin akan menghapus baris konfigurasi
              <b>{{ selected.label || selected.coa_number }}</b>?

              <div v-if="message.error.length > 0"
                class="text-center mt-3">
                <div class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>

                  <span class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>

            <v-divider
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions class="mb-2 px-4">
              <v-spacer/>

              <v-btn
                @click="toDelete()"
                :loading="process.delete"
                :disabled="process.delete"
                width="120"
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Hapus
              </v-btn>

              <v-btn
                @click="dialog.delete = false;"
                :disabled="process.delete"
                width="120"
                outlined
                elevation="0"
                color="grey"
                rounded
                class="body-2 font-weight-bold text-capitalize">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <v-card
            flat
            color="transparent">
            <v-card-text class="pt-1 pb-0">
              <div class="d-flex align-center">
                <div class="d-flex align-center">
                  <v-avatar tile size="22">
                    <v-img
                      contain
                      alt="arus-kas"
                      :src="require('@/assets/image/grip_menu.png')">
                      <template v-slot:placeholder>
                        <v-row class="fill-height" align="center" justify="center">
                          <v-progress-circular size="20" indeterminate :color="set_color"></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span class="fs-16 black--text ml-2" style="font-weight: 600;">
                    Konfigurasi Laporan Arus Kas
                  </span>
                </div>

                <v-spacer/>
              </div>

              <div class="mt-3">
                <v-tabs
                  v-model="tab"
                  dense
                  background-color="transparent"
                  slider-size="5"
                  :color="set_color">
                  <v-tab v-for="sec in sections" :key="sec.id">
                    <span class="body-2 font-weight-medium text-capitalize">
                      {{ sec.name }}
                    </span>
                  </v-tab>
                </v-tabs>
                <v-divider style="border-color: #EBEEF2;"></v-divider>
              </div>
            </v-card-text>
          </v-card>

          <v-row class="pa-5 pt-2 pb-0">
            <v-col cols="12" class="py-0">
              <div class="d-flex align-center pb-2">
                <v-btn
                  color="#4B4B4B"
                  elevation="0"
                  small
                  min-height="30"
                  class="fs-12 white--text text-capitalize d-flex align-center"
                  style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));"
                  @click="openForm()">
                  <v-icon size="15">mdi-plus-circle-multiple</v-icon>
                  <span class="ml-2">Tambah</span>
                </v-btn>

                <v-spacer/>

                <v-select
                  filled
                  rounded
                  dense
                  hide-details
                  :color="set_color"
                  :items="positions"
                  item-text="name"
                  item-value="id"
                  v-model="position"
                  class="fs-12"
                  style="border-radius: 6px; max-width: 160px;">
                </v-select>
              </div>

              <v-card
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-data-table
                  :loading="process.load"
                  loading-text="Sedang memuat data . . ."
                  loader-height="5"
                  no-data-text="Belum Ada Konfigurasi Arus Kas"
                  :headers="headers"
                  :items="filteredList"
                  :items-per-page="-1"
                  item-key="id"
                  hide-default-footer
                  hide-default-header
                  class="table-arus-kas-config"
                  :height="`calc(100vh - 300px)`">
                  <template v-slot:header="{ props: { headers: hd } }">
                    <thead>
                      <tr>
                        <th
                          v-for="h in hd"
                          :key="h.value"
                          :style="`min-width: ${h.width || ''}; width: ${h.width || ''}; background-color: ${set_color} !important; color: #fff;`"
                          :class="`text-${h.align}`">
                          <span class="fs-12">{{ h.text }}</span>
                        </th>
                      </tr>
                    </thead>
                  </template>

                  <template v-slot:item.action="{ item }">
                    <v-icon
                      size="18"
                      color="grey darken-1"
                      class="cursor-pointer mr-2"
                      @click="openEditForm(item)">
                      mdi-pencil-outline
                    </v-icon>

                    <v-icon
                      size="18"
                      color="red"
                      class="cursor-pointer"
                      @click="toDeleteDialog(item)">
                      mdi-trash-can-outline
                    </v-icon>
                  </template>

                  <template v-slot:item.coa_number="{ item }">
                    <span class="fs-12">{{ item.coa_number || '-' }}</span>
                  </template>

                  <template v-slot:item.label="{ item }">
                    <span class="fs-12" :style="isBoldRow(item) ? 'font-weight: 700;' : ''">{{ item.label }}</span>
                  </template>

                  <template v-slot:item.row_type="{ item }">
                    <span class="fs-12">{{ rowTypeName(item.row_type) }}</span>
                  </template>

                  <template v-slot:item.formula_type="{ item }">
                    <span class="fs-12">{{ formulaTypeName(item.formula_type) }}</span>
                  </template>

                  <template v-slot:item.balance_type="{ item }">
                    <span class="fs-12">{{ balanceTypeName(item.balance_type) }}</span>
                  </template>

                  <template v-slot:item.sort="{ item }">
                    <span class="fs-12">{{ item.sort }}</span>
                  </template>

                  <template v-slot:item.active_bool="{ item }">
                    <v-chip
                      x-small
                      label
                      :color="isActive(item.active_bool) ? 'green' : 'grey'"
                      class="white--text fs-11">
                      {{ isActive(item.active_bool) ? 'Aktif' : 'Nonaktif' }}
                    </v-chip>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post } from "@/service/Axios";

  export default {
    data () {
      return {
        tab: 0,

        dialog: {
          fullscreen: false,
          snackbar: false,
          form: false,
          delete: false
        },

        // section: operasi / investasi / kas
        sections: [
          { id: 'operasi', name: 'Aktivitas Operasi' },
          { id: 'investasi', name: 'Aktivitas Investasi' },
          { id: 'kas', name: 'Kas dan Setara Kas' }
        ],
        // row_type: header / note / item / formula / total
        rowTypes: [
          { id: 'header', name: 'Judul' },
          { id: 'note', name: 'Catatan' },
          { id: 'item', name: 'Akun' },
          { id: 'formula', name: 'Rumus' },
          { id: 'total', name: 'Total' }
        ],
        // formula_type: opsional, kosong = none (otomatis jadi neraca_diff kalau coa_number diisi)
        formulaTypes: [
          { id: '', name: 'Otomatis (Kosong)' },
          { id: 'none', name: 'Tidak Ada' },
          { id: 'neraca_diff', name: 'Selisih Neraca' },
          { id: 'modal_bulan', name: 'Selisih Modal Bulanan' },
          { id: 'laba_rugi', name: 'Laba Rugi' },
          { id: 'sum_section', name: 'Total Section' },
          { id: 'kas_bersih', name: 'Kas Bersih' },
          { id: 'kas_awal', name: 'Kas Awal' },
          { id: 'kas_ending', name: 'Kas Akhir' },
          { id: 'sum_activities', name: 'Kas Bersih (Lama)' }
        ],
        // balance_type: opsional, kosong = ambil dari coa_type
        balanceTypes: [
          { id: '', name: 'Otomatis (Kosong)' },
          { id: 'aktiva', name: 'Aktiva' },
          { id: 'pasiva', name: 'Pasiva' }
        ],
        position: 'internal',
        positions: [
          { id: 'internal', name: 'Internal' },
          { id: 'public', name: 'Public' }
        ],

        headers: [
          { text: 'Aksi', value: 'action', align: 'center', width: '90px', sortable: false },
          { text: 'Label', value: 'label', align: 'start', sortable: false, width: '100%' },
          { text: 'Akun COA', value: 'coa_number', align: 'start', width: '130px', sortable: false },
          { text: 'Tipe Baris', value: 'row_type', align: 'start', width: '100px', sortable: false },
          { text: 'Formula', value: 'formula_type', align: 'start', width: '130px', sortable: false },
          { text: 'Saldo', value: 'balance_type', align: 'start', width: '100px', sortable: false },
          { text: 'Urutan', value: 'sort', align: 'center', width: '80px', sortable: false },
          { text: 'Status', value: 'active_bool', align: 'center', width: '100px', sortable: false }
        ],

        list: [],
        coaOptions: [],
        search_coa: '',
        selected: {},

        form: {
          id: '',
          section: 'operasi',
          row_type: 'item',
          coa_number: '',
          label: '',
          formula_type: '',
          balance_type: '',
          sort: 0,
          active_bool: 1
        },

        process: {
          load: false,
          form: false,
          delete: false,
          coa: false
        },

        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      set_color () {
        return this.$store.state.color
      },
      filteredList () {
        let section = this.sections[this.tab] ? this.sections[this.tab].id : 'operasi'

        return this.list
          .filter(item => item.section === section)
          .slice()
          .sort((a, b) => (parseInt(a.sort) || 0) - (parseInt(b.sort) || 0))
      },
      coaSelectItems () {
        return this.coaOptions.map(item => ({
          number: item.number,
          name: item.name,
          name_number: item.number && item.name ? `${item.number} - ${item.name}` : (item.name || item.number)
        }))
      },
      // label wajib hanya kalau tidak pilih akun COA
      labelRules () {
        return this.form.coa_number ? '' : 'required'
      }
    },
    watch: {
      position () {
        this.fetch()
        this.fetchCoaOptions()
      }
    },
    mounted () {
      this.fetch()
      this.fetchCoaOptions()
    },
    methods: {
      rowTypeName (id) {
        let found = this.rowTypes.find(item => item.id === id)
        return found ? found.name : id
      },

      formulaTypeName (id) {
        let found = this.formulaTypes.find(item => item.id === id)
        return found && found.id ? found.name : '-'
      },

      balanceTypeName (id) {
        let found = this.balanceTypes.find(item => item.id === id)
        return found && found.id ? found.name : '-'
      },

      isBoldRow (item) {
        return item.row_type === 'header' || item.row_type === 'total'
      },

      // BE balikin active_bool sbg boolean asli (true/false), bukan 1/0
      isActive (value) {
        return value === true || value === 1 || value === '1'
      },

      // isi label otomatis dari nama COA yang dipilih (masih bisa diedit manual)
      onCoaChange (number) {
        if (!number) return

        let found = this.coaOptions.find(item => item.number === number)

        if (found && !this.form.label) this.form.label = found.name
      },

      async fetchCoaOptions () {
        this.process.coa = true

        await get(`arus-kas/config/coa/options`, {
          params: { position: this.position }
        }).then(response => {
          let res = response.data

          this.process.coa = false

          if (res.status === 200) {
            this.coaOptions = res.results.data || []
          }
        })
      },

      async fetch () {
        this.process.load = true
        this.list = []

        await get(`arus-kas/config/data`, {
          params: { position: this.position }
        }).then(response => {
          let res = response.data

          this.process.load = false

          if (res.status === 200) {
            this.list = res.results.data || []
          }
        })
      },

      reset () {
        this.message.error = ''

        this.form = {
          id: '',
          section: this.sections[this.tab] ? this.sections[this.tab].id : 'operasi',
          row_type: 'item',
          coa_number: '',
          label: '',
          formula_type: '',
          balance_type: '',
          sort: 0,
          active_bool: 1
        }

        if (this.$refs.form) this.$refs.form.reset()
      },

      openForm () {
        this.reset()
        this.dialog.form = true
      },

      openEditForm (item) {
        this.message.error = ''

        this.form = {
          id: item.id,
          section: item.section,
          row_type: item.row_type,
          coa_number: item.coa_number || '',
          label: item.label || '',
          formula_type: item.formula_type || '',
          balance_type: item.balance_type || '',
          sort: item.sort,
          active_bool: this.isActive(item.active_bool) ? 1 : 0
        }

        this.dialog.form = true
      },

      // hanya kirim field yang diisi — kosong = biar backend pakai default dari COA
      buildPayload () {
        const payload = {
          section: this.form.section,
          row_type: this.form.row_type,
          sort: parseInt(this.form.sort) || 0,
          active_bool: parseInt(this.form.active_bool) === 1 ? true : false
        }

        if (this.form.coa_number) payload.coa_number = this.form.coa_number
        if (this.form.label) payload.label = this.form.label
        if (this.form.formula_type) payload.formula_type = this.form.formula_type
        if (this.form.balance_type) payload.balance_type = this.form.balance_type

        return payload
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          const isEdit = !!this.form.id
          const payload = this.buildPayload()

          if (isEdit) payload.id = this.form.id

          await post(`arus-kas/config/${isEdit ? 'update' : 'add'}`, {
            data: payload
          }).then(response => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false
              this.dialog.fullscreen = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.reset()
              this.fetch()
            } else {
              this.message.error = res.message
            }
          })
        }
      },

      toDeleteDialog (item) {
        this.message.error = ''
        this.selected = item

        this.dialog.delete = true
      },

      async toDelete () {
        this.message.error = ''
        this.process.delete = true

        await post(`arus-kas/config/delete`, {
          data: { id: this.selected.id }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {
            this.dialog.delete = false

            this.dialog.snackbar = true
            this.message.success = res.message

            this.selected = {}
            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>

<style scoped>
  .table-arus-kas-config >>> table > thead > tr > th {
    font-weight: 600 !important;
    font-size: 12px !important;
    height: 40px !important;
  }
  .table-arus-kas-config >>> table > tbody > tr > td {
    font-size: 12px !important;
    height: 40px !important;
  }
  .table-arus-kas-config >>> table > tbody > tr:hover {
    background: #f0f4fa !important;
  }
</style>